var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import styled from 'styled-components';
function Switch(_a) {
    var value = _a.value, setValue = _a.setValue, _b = _a.active, active = _b === void 0 ? true : _b;
    var _c = React.useState(value), localValue = _c[0], setLocalValue = _c[1];
    useEffect(function () {
        setLocalValue(value);
    }, [value]);
    function toggle() {
        if (active) {
            if (setValue) {
                setValue(!localValue);
            }
            setLocalValue(!localValue);
        }
    }
    return (_jsx(SwitchButton, { active: active, disabled: !active, localValue: !!localValue, onClick: toggle, children: _jsx("div", { className: "cursor" }) }));
}
export default Switch;
var SwitchButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 3rem;\n  height: 1.5rem;\n  display: flex;\n  align-items: center;\n  border-radius: 9999px;\n  padding: 0.25rem;\n  transition: background-color 0.3s;\n  background-color: ", ";\n  opacity: ", ";\n  cursor: ", ";\n\n  .cursor {\n    width: 1rem;\n    height: 1rem;\n    background-color: white;\n    border-radius: 9999px;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);\n    transform: ", ";\n    transition: transform 0.3s;\n  }\n"], ["\n  width: 3rem;\n  height: 1.5rem;\n  display: flex;\n  align-items: center;\n  border-radius: 9999px;\n  padding: 0.25rem;\n  transition: background-color 0.3s;\n  background-color: ", ";\n  opacity: ", ";\n  cursor: ", ";\n\n  .cursor {\n    width: 1rem;\n    height: 1rem;\n    background-color: white;\n    border-radius: 9999px;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);\n    transform: ", ";\n    transition: transform 0.3s;\n  }\n"])), function (_a) {
    var localValue = _a.localValue, theme = _a.theme;
    return (localValue ? theme.palette.valid : 'gray');
}, function (_a) {
    var active = _a.active;
    return (active ? 1 : 0.5);
}, function (_a) {
    var active = _a.active;
    return (active ? 'pointer' : 'not-allowed');
}, function (_a) {
    var localValue = _a.localValue;
    return (localValue ? 'translateX(1.5rem)' : 'translateX(0)');
});
var templateObject_1;
